"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _semver = _interopRequireDefault(require("semver"));
var _reactRouterDom = require("react-router-dom");
var _Tooltip = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Tooltip"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _excluded = ["isDisabled"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var LinkIcon = function LinkIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.003 3.544a5.27 5.27 0 1 1 7.453 7.453l-3.45 3.45a5.271 5.271 0 0 1-6.885.495 1 1 0 1 1 1.2-1.6 3.271 3.271 0 0 0 4.27-.309l3.451-3.45a3.27 3.27 0 0 0-4.625-4.625l-.431.431a1 1 0 1 1-1.414-1.414l.431-.431zm-.324 7.115a3.271 3.271 0 0 0-4.27.307l-3.451 3.451a3.27 3.27 0 1 0 4.625 4.625l.431-.431a1 1 0 0 1 1.414 1.414l-.431.431a5.27 5.27 0 0 1-7.453-7.453l3.45-3.45a5.271 5.271 0 0 1 6.885-.494 1 1 0 1 1-1.2 1.6z"
  }));
};
LinkIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var styles = {
  "asset-name": "asset-name_3jXGt-",
  "assetName": "asset-name_3jXGt-",
  "container": "container_1YsjUz",
  "open-icon": "open-icon_1-ZgE7",
  "openIcon": "open-icon_1-ZgE7",
  "disabled": "disabled_1wmyry",
  "tooltip-content": "tooltip-content_1_wolK",
  "tooltipContent": "tooltip-content_1_wolK",
  "minor-version-pill": "minor-version-pill_1pcVKk",
  "minorVersionPill": "minor-version-pill_1pcVKk"
}; 
require('./AssetNameLink.css');
var linkIcon = /*#__PURE__*/_react.default.createElement(_Icon.default, {
  className: styles.openIcon,
  size: 21
}, /*#__PURE__*/_react.default.createElement(LinkIcon, null));
var getMinorVersion = function getMinorVersion(version) {
  return "".concat(_semver.default.major(version), ".").concat(_semver.default.minor(version), ".x");
};
var DisabledTooltip = function DisabledTooltip(_ref) {
  var children = _ref.children,
    asset = _ref.asset,
    showMinorVersionPill = _ref.showMinorVersionPill,
    className = _ref.className,
    testId = _ref.testId;
  var elementName = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(0),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    width = _useState2[0],
    setWidth = _useState2[1];
  var _useState3 = (0, _react.useState)(0),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    height = _useState4[0],
    setHeight = _useState4[1];
  var offset = (0, _react.useMemo)(function () {
    return [width, height];
  }, [width, height]);
  (0, _react.useEffect)(function () {
    setWidth(-elementName.current.offsetWidth + 10);
    setHeight(-elementName.current.offsetHeight);
  }, [elementName]);
  return /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    className: className,
    testId: testId,
    "aria-describedby": "asset-tooltip",
    offset: offset,
    position: "right",
    content: /*#__PURE__*/_react.default.createElement("div", {
      className: styles.tooltipContent
    }, /*#__PURE__*/_react.default.createElement("span", {
      id: "no-permissions-tooltip-text"
    }, "You don't have permissions to view this asset."))
  }, /*#__PURE__*/_react.default.createElement("span", {
    ref: elementName
  }, children !== null && children !== void 0 ? children : asset.name), showMinorVersionPill && asset.version ? /*#__PURE__*/_react.default.createElement("span", {
    className: styles.minorVersionPill
  }, getMinorVersion(asset.version)) : null);
};
DisabledTooltip.defaultProps = {
  testId: 'asset-name',
  showMinorVersionPill: false
};
var VersionLink = function VersionLink(_ref2) {
  var children = _ref2.children,
    targetPath = _ref2.targetPath,
    asset = _ref2.asset,
    showMinorVersionPill = _ref2.showMinorVersionPill,
    onClick = _ref2.onClick,
    className = _ref2.className,
    target = _ref2.target,
    testId = _ref2.testId,
    useFullURLPath = _ref2.useFullURLPath;
  var getPath = (0, _exchangeReactHooks.useGetPath)();
  var portalPath = targetPath !== null && targetPath !== void 0 ? targetPath : getPath('page', asset, {
    useFullURLPath: useFullURLPath,
    excludeQueryParams: true
  });
  var link = (0, _react.useMemo)(function () {
    return target === 'self-nav-link' ? /*#__PURE__*/_react.default.createElement(_reactRouterDom.NavLink, {
      onClick: onClick,
      className: styles.container,
      to: portalPath,
      "aria-label": "Navigate to asset portal",
      "data-test-id": "".concat(testId, "-anchor")
    }, linkIcon) : /*#__PURE__*/_react.default.createElement("a", {
      onClick: onClick,
      className: styles.container,
      href: portalPath,
      target: target === 'blank' ? '_blank' : '_self',
      rel: "noopener noreferrer",
      "aria-label": "Navigate to asset portal",
      "data-test-id": "".concat(testId, "-anchor")
    }, linkIcon);
  }, [target, onClick, portalPath, testId]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(className, styles.assetName),
    "data-test-id": testId
  }, children !== null && children !== void 0 ? children : asset.name, showMinorVersionPill && asset.version ? /*#__PURE__*/_react.default.createElement("span", {
    className: styles.minorVersionPill
  }, getMinorVersion(asset.version)) : null, link);
};
VersionLink.defaultProps = {
  showMinorVersionPill: false,
  testId: 'asset-name',
  target: 'blank',
  onClick: function onClick() {}
};
var AssetNameLink = function AssetNameLink(_ref3) {
  var isDisabled = _ref3.isDisabled,
    props = (0, _objectWithoutProperties2.default)(_ref3, _excluded);
  return isDisabled ? /*#__PURE__*/_react.default.createElement(DisabledTooltip, props) : /*#__PURE__*/_react.default.createElement(VersionLink, props);
};
AssetNameLink.defaultProps = {
  isDisabled: false
};
var _default = exports.default = AssetNameLink;
//# sourceMappingURL=AssetNameLink.js.map